import { MAX_ADDRESS_QUERY_LENGTH } from "@/consts";
import { getAddressesByString } from "@/api/routes/address";

export const fetchSuggestionsConstructor = (asyncCb) => {
    return async function (queryString, cb) {
        if (!queryString?.length || queryString?.length >= MAX_ADDRESS_QUERY_LENGTH) {
            return cb([])
        }
        try {
            const data = await asyncCb(queryString);
            let addresses = [];
            data.forEach((address) => {
                if (address?.code === 'user_manual' || !!address?.houseGuid) {
                    addresses.push(address);
                }
            });

            if (addresses.length <= 0) {
                addresses.push({
                    value: queryString,
                    code: 'user_manual',
                });
            }
            cb(addresses);
        } catch(err) {
            throw new Error(err)
        }
    }
}

export const fetchAddressSuggestions = () => {
    return fetchSuggestionsConstructor(getAddressesByString)
}

export const debounce = (func, timeout = 300) => {
    let timer;
    
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }